(() => {
  if (window.AsanovSizeChartLoaded) return;
  window.AsanovSizeChartLoaded = true;

  let activeModal = null;
  let lastFocusedElement = null;

  const getFocusable = (container) => Array.from(
    container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
  ).filter((element) => !element.hasAttribute('disabled') && element.offsetParent !== null);

  const openModal = (modal, trigger) => {
    if (!modal) return;
    activeModal = modal;
    lastFocusedElement = trigger;
    modal.hidden = false;
    document.body.classList.add('asanov-size-chart-open');
    requestAnimationFrame(() => {
      modal.querySelector('[data-size-chart-close]')?.focus();
    });
  };

  const closeModal = (modal = activeModal) => {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('asanov-size-chart-open');
    activeModal = null;
    lastFocusedElement?.focus();
    lastFocusedElement = null;
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-size-chart-open]');
    if (openButton) {
      const chart = openButton.closest('[data-asanov-size-chart]');
      openModal(chart?.querySelector('[data-size-chart-modal]'), openButton);
      return;
    }

    const closeButton = event.target.closest('[data-size-chart-close]');
    if (closeButton) {
      closeModal(closeButton.closest('[data-size-chart-modal]'));
      return;
    }

    /* Close when the user taps any empty overlay area outside the image panel. */
    if (activeModal && event.target === activeModal) {
      closeModal(activeModal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!activeModal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key === 'Tab') {
      const focusable = getFocusable(activeModal);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
